import { Api } from 'core/api';

const uploadFileApi = new Api({
  options: {
    method: 'POST',
  },
  url: '/files/upload-url',
});

const uploadFile = (key: string) => {
  return uploadFileApi.simpleFetch({
    options: {
      body: JSON.stringify({
        key,
      }),
    },
  });
};

export { uploadFile };
